:host {
    display: block;
}
::slotted(*) {
    border-radius: 5px;
}
atlantis-contact-card-with-button {
    --tti-card-border-width: 0;
}